/**
 * Shim for `react-native-device-info` returning browser-appropriate values.
 */
const appVersion = __APP_VERSION__;

const DeviceInfo = {
  getUniqueIdSync: () => {
    let id = window.localStorage.getItem('device-unique-id');
    if (!id) {
      id = (crypto as any).randomUUID?.() ?? `${Date.now()}-${Math.random()}`;
      window.localStorage.setItem('device-unique-id', id);
    }
    return id;
  },
  getUniqueId: async () => DeviceInfo.getUniqueIdSync(),
  getModel: () => navigator.userAgent,
  getBrand: () => navigator.vendor || 'web',
  getSystemName: () => navigator.platform || 'web',
  getSystemVersion: () => '',
  getVersion: () => appVersion,
  getBuildNumber: () => '1',
  getBundleId: () => 'com.exxonmobil.opslogbook.web',
  getApplicationName: () => 'Operations Logbook',
  getDeviceId: () => navigator.userAgent,
  isTablet: () => false,
  hasNotch: () => false,
};

export default DeviceInfo;
